import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	buttonLabelSuggestWorkItems: {
		id: 'backlog.card-list.inline-card-create.ai-assisted-create.ai-suggest-button.button-label-suggest-work-items',
		defaultMessage: 'Suggest Work Items',
		description: 'Text used in the suggest issue button for AI assisted work create in backlog.',
	},
});
